<app-input type="tel"
           #telInput
           [label]="label"
           [disabled]="disabled"
           [fc]="fc"></app-input>
